// generated by genversion
export var version = '3.2.6';
//# sourceMappingURL=version.js.map